import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router";
import { Container } from "reactstrap";
import ScrollspyNav from "./scrollSpy";

class Topbar extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            isOpen : false, 
            navLinks : [
                { id : 1, idnm:"home", title : "Inicio", link : "/#" },
                { id : 2, idnm:"features", title : "Características", link : "/#"},
                { id : 3, idnm:"focus", title : "Objetivo", link : "/#"},
                { id : 4, idnm:"integrations", title : "Integraciones", link : "/#"},
            ]
         };
        this.toggleLine = this.toggleLine.bind(this);
    }

    toggleLine() {
        this.setState(prevState => ({  isOpen: !prevState.isOpen }));
    }

    render() {
        //Store all Navigationbar Id into TargetID variable(Used for Scrollspy)
        let targetId = this.state.navLinks.map((item) => {
            return(
                item.idnm
            )
        });
        return (
            <React.Fragment>
                <header id="topnav" className="defaultscroll sticky">
                    <Container>
                        <div>
                            <Link className="logo" to="/index">Rindo</Link>
                        </div>
                        <div className="buy-button">
                            {/* <a href="https://id.rindoapp.com/signup" className="btn btn-warning">Prueba Gratis Rindo</a> */}
                            <a href="https://calendly.com/jpbarahona/demo-rindo" className="btn btn-warning">Solicita una Demo</a>
                        </div>
                        <div className="buy-button">
                            <a href="https://id.rindoapp.com" className="btn btn-primary">Ingresar</a>
                        </div>
                        <div className="menu-extras">
                            <div className="menu-item">
                                <Link to="#" onClick={ this.toggleLine } className={this.state.isOpen ? "navbar-toggle open" : "navbar-toggle" } >
                                    <div className="lines">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <ScrollspyNav
                            scrollTargetIds={targetId}
                            scrollDuration="800"
                            headerBackground="false"
                            activeNavClass="active"
                        >
                            <div id="navigation" style={{ display : this.state.isOpen ? "block" : "none" }}>
                                <ul className="navigation-menu">
                                    {this.state.navLinks.map((item, key) => (
                                        <li key={key} className="has-submenu">
                                            <a href={"#" + item.idnm} > {item.title}</a>
                                        </li>
                                    ))} 
                                </ul>
                                <div className="buy-menu-btn d-none">
                                    <a href="https://id.rindoapp.com" target="_blank" className="btn btn-primary">Ingresar</a>
                                </div>
                                <div className="buy-menu-btn d-none">
                                    <a href="https://id.rindoapp.com/signup" target="_blank" className="btn btn-warning">Prueba Gratis Rindo</a>
                                </div>
                            </div>
                        </ScrollspyNav>
                    </Container>
                </header>
            </React.Fragment>
        );
    }
}

export default withRouter(Topbar);